<aside id="app-sidebar" class="sidebar" [class.collapsed]="collapsed && !isMobile"
  [class.mobile-open]="mobileOpen && isMobile">

  <!-- =====================================================
       BRAND
  ====================================================== -->

  <div class="sidebar-brand">

    <div class="brand-logo">
      <img
          class="logo"
          [src]="
            currentUser?.company_logo
              ? companyUrl + currentUser.company_logo
              : 'assets/images/ab_assist.png'
          "
          alt="Company Logo"
        />
    </div>

    @if (!collapsed || isMobile) {

    <div class="brand-content">

      <div class="brand-title">
        {{ currentUser?.title || "Absence Law Assistance" }}
      </div>

      <div class="brand-subtitle">
        {{ currentUser?.caption || "Learning Platform" }}
      </div>

    </div>

    }

  </div>


  <!-- =====================================================
       NAVIGATION
  ====================================================== -->

  <nav class="sidebar-navigation">

    @for (item of menuList; track item.menu_name) {

    <a class="sidebar-item" [routerLink]="['/', urlFormation(item.menu_name)]" routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }" (click)="onNavigation()" [pTooltip]="item.display_menu"
      tooltipPosition="right" [tooltipDisabled]="!collapsed || isMobile" tooltipStyleClass="small-tooltip">

      <span class="sidebar-icon">

        @if (item.notify_count > 0) {

        <span class="notification-badge">
          {{ item.notify_count }}
        </span>

        }


        @if (
        item.menu_name !== 'aiassist' &&
        item.menu_name !== 'talkai'
        ) {

        <i class="pi" [ngClass]="menuIcon[item.menu_name]"></i>

        }


        @if (item.menu_name === 'talkai') {

        <img [src]="menuIcon[item.menu_name]" alt="" />

        }


        @if (item.menu_name === 'aiassist') {

        <i class="fa" [ngClass]="menuIcon[item.menu_name]"></i>

        }

      </span>


      @if (!collapsed || isMobile) {

      <span class="sidebar-label">
        {{ item.display_menu }}
      </span>

      }

    </a>

    }

  </nav>


  <!-- =====================================================
       SIDEBAR BOTTOM
  ====================================================== -->

  <div class="sidebar-bottom">


    <!-- ===================================================
         DESKTOP COLLAPSE / EXPAND
         NOT SHOWN ON MOBILE
    ==================================================== -->

    @if (!isMobile) {

    <button type="button" class="collapse-button" (click)="toggleCollapse()" [attr.aria-label]="
          collapsed ? 'Expand menu' : 'Collapse menu'
        " [attr.aria-expanded]="!collapsed">

      <span class="collapse-icon">

        <i class="pi" [class.pi-angle-double-left]="!collapsed" [class.pi-angle-double-right]="collapsed"></i>

      </span>


      @if (!collapsed) {

      <span class="collapse-label">
        Collapse menu
      </span>

      }

    </button>

    }


    <!-- ===================================================
         MOBILE CLOSE
    ==================================================== -->

    @if (isMobile) {

    <button type="button" class="mobile-close-button" (click)="closeMobile.emit()" aria-label="Close menu">

      <span class="collapse-icon">
        <i class="pi pi-times"></i>
      </span>

      <span class="collapse-label">
        Close menu
      </span>

    </button>

    }


    <!-- ===================================================
         USER PROFILE
    ==================================================== -->

    <div class="sidebar-user">

      <!-- Avatar -->
      <div class="user-avatar" aria-hidden="true">

        @if (userDetail?.user_icon) {
        <img [src]="profileUrl + userDetail.user_icon" [alt]="userDetail?.first_name || 'User'" class="user-avatar-image" />
        } @else {
        <span class="user-avatar-letter">
          {{ userDetail?.first_name?.charAt(0)?.toUpperCase() || 'U' }}
        </span>
        }

      </div>

      <!-- User information -->
      @if (!collapsed || isMobile) {
      <div class="user-information">

        <div class="user-name" [title]="userDetail?.first_name + ' ' + userDetail?.last_name">
          {{ userDetail?.first_name }} {{ userDetail?.last_name }}
        </div>

        <div class="user-email" [title]="userDetail?.email_id">
          {{ userDetail?.email_id }}
        </div>

      </div>
      }

      <!-- Logout -->
      @if (!collapsed || isMobile) {
      <button type="button" class="logout-button" title="Sign out" aria-label="Sign out" (click)="logout()">
        <i class="bi bi-box-arrow-right"></i>
      </button>
      }

    </div>


    <!-- ===================================================
         COLLAPSED DESKTOP LOGOUT
    ==================================================== -->

    @if (collapsed && !isMobile) {

    <button type="button" class="collapsed-logout-button" title="Sign out" aria-label="Sign out" (click)="logout()">

      <i class="bi bi-box-arrow-right"></i>

    </button>

    }

  </div>

</aside>
